const AttachmentList = ({ children }) => {
  return (
    <div className='flex flex-wrap gap-3 p-3 bg-background dark:bg-input/30'>
      {children}
    </div>
  )
}

export default AttachmentList
